import COS from 'cos-js-sdk-v5'
import { getFileCredAppV1 } from '@/service/config-manager.js'
const CryptoJS = require('crypto-js')

// AES解密
export function decryptByAES(ciphertext) {
    const key = ')O[NB]6,YF}+efca'
    const keyHex = CryptoJS.enc.Utf8.parse(key)
    // direct decrypt ciphertext
    const decrypted = CryptoJS.AES.decrypt(
        {
            ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
        },
        keyHex,
        {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    )
    return decrypted.toString(CryptoJS.enc.Utf8)
}

// let cos = new COS({
//     // 必选参数
//     getAuthorization: function(options, callback) {
//         getCostemp().then(res => {
//             let data = res
//             callback({
//                 TmpSecretId: data.tmpSecretId,
//                 TmpSecretKey: data.tmpSecretKey,
//                 XCosSecurityToken: data.sessionToken,
//                 ExpiredTime: data.expiredTime // SDK 在 ExpiredTime 时间前，不会再次调用 getAuthorization
//             })
//         })
//     }
// })
export function getCosUrl(url, Sign = true) {
    if (!url) {
        return
    }
    url = decodeURIComponent(url)
    return new Promise((resolve, reject) => {
        // let Bucket = url.match(/(?<=\/\/).*?(?=.cos)/)[0]
        // let Region = url.match(/(?<=cos.).*?(?=.myqcloud)/)[0]
        // let Key = url.match(/(?<=.myqcloud.com).*/)[0]
        try {
            let urlArray = url.split('.myqcloud.com')
            let Bucket = urlArray[0].split('.cos.')[0].split('//')[1]
            let Region = urlArray[0].split('.cos.')[1]
            let Key = urlArray[1]
            const cos = new COS({
                // 必选参数
                getAuthorization: function(options, callback) {
                    getFileCredAppV1({
                        bucket: Bucket,
                        fileName: Key,
                        region: Region
                    }).then(res => {
                        let data = res
                        let jsonData = {}
                        try {
                            jsonData = JSON.parse(
                                CryptoJS.enc.Base64.parse(data).toString(
                                    CryptoJS.enc.Utf8
                                )
                            )
                        } catch (e) {
                            jsonData = {}
                            console.log('解密失败')
                        }
                        callback({
                            TmpSecretId: jsonData.tmpSecretId,
                            TmpSecretKey: decryptByAES(jsonData.tmpSecretKey),
                            XCosSecurityToken: decryptByAES(
                                jsonData.sessionToken
                            ),
                            ExpiredTime: jsonData.expiredTime // SDK 在 ExpiredTime 时间前，不会再次调用 getAuthorization
                        })
                    })
                }
            })
            cos.getObjectUrl(
                {
                    Bucket,
                    Region,
                    Key,
                    Sign
                },
                function(err, data) {
                    if (!err) {
                        resolve(data.Url)
                    }
                    reject(err)
                }
            )
        } catch (e) {
            reject(e)
        }
    })
}
